<script>
export default {
  name: "CrmSummaryCards",
  props: {
    credit: {
      type: [Number, String],
      default: 0
    },
    packageCount: {
      type: [Number, String],
      default: 0
    },
    voucherCount: {
      type: [Number, String],
      default: 0
    },
    creditRoute: {
      type: String,
      default: "/spa-wallet/credit"
    },
    packageRoute: {
      type: String,
      default: "/spa-wallet/package"
    },
    voucherRoute: {
      type: String,
      default: "/spa-wallet/voucher"
    },
    dataTestPrefix: {
      type: String,
      default: "home"
    }
  },
  computed: {
    summaryClass() {
      return {
        "crm-summary--spa-wallet": this.dataTestPrefix === "spa-wallet"
      };
    }
  }
};
</script>

<template>
  <section
    class="crm-summary"
    :class="summaryClass"
    :data-test="`${dataTestPrefix}-summary`"
  >
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-credit-summary`"
      @click="$router.push(creditRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${$baseUrl}svg/credit.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <span class="crm-summary__value">
          {{ numeralFormat(credit) }}
          <!-- <span data-lang="credit_unit" class="crm-summary__unit">{{ $t("credit_unit") }}</span> -->
        </span>
        <span data-lang="credit_balance" class="crm-summary__label">{{ $t("credit_balance") }}</span>
      </div>
    </button>
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-package-summary`"
      @click="$router.push(packageRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${$baseUrl}svg/service.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <span class="crm-summary__value">
          {{ packageCount }}
          <!-- <span data-lang="list" class="crm-summary__unit">{{ $t("list") }}</span> -->
        </span>
        <span data-lang="package_balance" class="crm-summary__label">{{ $t("package_balance") }}</span>
      </div>
    </button>
    <button
      type="button"
      class="crm-summary__card"
      :data-test="`${dataTestPrefix}-voucher-summary`"
      @click="$router.push(voucherRoute)"
    >
      <span
        class="crm-summary__icon"
        :style="{ '--icon-url': `url(${$baseUrl}svg/gift-02.svg)` }"
        aria-hidden="true"
      ></span>
      <font-awesome-icon
        :icon="['fas', 'chevron-right']"
        class="crm-summary__chevron"
        aria-hidden="true"
      />
      <div class="crm-summary__content">
        <span class="crm-summary__value">
          {{ voucherCount }}
          <!-- <span data-lang="list" class="crm-summary__unit">{{ $t("list") }}</span> -->
        </span>
        <span data-lang="voucher_balance" class="crm-summary__label">{{ $t("voucher_balance") }}</span>
      </div>
    </button>
  </section>
</template>

<style lang="scss" scoped>
.crm-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 16px 0;
}

.crm-summary__card {
  position: relative;
  display: flex;
  min-width: 0;

  flex-direction: column;
  align-items: flex-start;
  border: 0;
  border-radius: var(--crm-border-radius);
  background: var(--secondary-color);
  padding: 12px;
  // box-shadow: var(--crm-box-shadow);
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.crm-summary__chevron {
  position: absolute;
  top: 17px;
  right: 16px;
  color: var(--crm-link-color);
  font-size: var(--font-body);
}

.crm-summary__content {
  min-width: 0;
  margin-top: 0.75rem;
}

.crm-summary__value {
  display: block;
  overflow: hidden;
  color: #222;
  font-size: var(--font-body-lg);
  font-weight: 900;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.crm-summary__unit {
  font-size: var(--font-body-sm);
  // font-weight: 500;
}

.crm-summary__label {
  display: block;
  overflow: hidden;

  color: #b1b1b1;
  font-size: var(--font-body-sm);
  // line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crm-summary--spa-wallet {
  gap: 10px;
  margin: 0px 4px 24px;
}

.crm-summary--spa-wallet .crm-summary__card {
  min-height: 105px;
  border-radius: 16px;
  padding: 18px 14px 16px;
  // box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.crm-summary--spa-wallet .crm-summary__chevron {
  top: 20px;
  right: 13px;
  font-size: var(--font-body-sm);
}

.crm-summary--spa-wallet .crm-summary__content {
  margin-top: 14px;
}

.crm-summary--spa-wallet .crm-summary__value {
  font-size: var(--font-body-lg);
}

@media (max-width: 360px) {
  .crm-summary--spa-wallet {
    gap: 10px;
    margin-right: 0;
    margin-left: 0;
  }

  .crm-summary--spa-wallet .crm-summary__card {
    min-height: 108px;
    padding: 16px 10px 14px;
  }
}
</style>
